import { render, staticRenderFns } from "./PatientTemp.vue?vue&type=template&id=3668dac8&scoped=true&"
import script from "./PatientTemp.vue?vue&type=script&lang=js&"
export * from "./PatientTemp.vue?vue&type=script&lang=js&"
import style0 from "./PatientTemp.vue?vue&type=style&index=0&id=3668dac8&lang=scss&scoped=true&"
import style1 from "./PatientTemp.vue?vue&type=style&index=1&id=3668dac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668dac8",
  null
  
)

export default component.exports